import { useContext, useCallback } from 'react';
import { RecommendationContext } from '@bingads-webui-campaign-react/perf-max-recommendation';
import { logCopilotRecommendations } from '@bingads-webui-campaign-react/copilot-common';

export const useAppliedLog = ({ campaignId }) => {
  const [recommendationContext] = useContext(RecommendationContext);
  const logAppliedSuggestion = useCallback(({
    assetData,
    isEditing,
  }) => {
    logCopilotRecommendations({
      recommendationContext,
      assetGroup: assetData,
      campaignId,
      isEditing,
    });
  }, [campaignId, recommendationContext]);

  return {
    logAppliedSuggestion,
  };
};
